export const email = {
  label: {
    emailUnknown: "I Don't Know",
    or: 'or',
  },
};
